<img [class.star]="isBulgariStar" [src]="src" alt="Bulgari asset" (error)="handleOnError()">
